import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Check } from 'lucide-react';

const Notification = ({ message, type }) => (
  <motion.div
    className={`toast-notification ${type === 'error' ? 'toast-error' : 'toast-success'}`}
    initial={{ opacity: 0, x: 50 }}
    animate={{ opacity: 1, x: 0 }}
    exit={{ opacity: 0, x: 50 }}
  >
    <div className="toast-icon">
      {type === 'error' ? <X size={20} color="#EF4444" /> : <Check size={20} color="#10B981" />}
    </div>
    <span>{message}</span>
  </motion.div>
);

export default function Toast({ notification }) {
  return (
    <AnimatePresence>
      {notification && (
        <div className="toast-container">
          <Notification message={notification.message} type={notification.type} />
        </div>
      )}
    </AnimatePresence>
  );
}
